import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  unit,
  status,
  heat_treatment,
  surface_treatment,
  target_date,
  remarks,
  leadTime,
} from '@/table/Job/SubJob/base';
import useSubJob from '@/use/useSubJob';

const {
  translateSubJobStatus, statusClassMap,
} = useSubJob();

function getStatus(
  overallStatus: string,
  computedStatus: string,
  processStatus: string | null = null,
  assemblyStatus: string | null = null,
) {
  if (assemblyStatus === 'DONE') return 'DONE';
  if (assemblyStatus === 'FAILED_ASSEMBLY') return 'FAILED_ASSEMBLY';
  if (overallStatus === 'ASSEMBLY') return 'ASSEMBLY';
  if (overallStatus === 'REVISE' || overallStatus === 'MODIFY') return overallStatus;
  return computedStatus;
}

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    amount,
    store_amount: {
      name: 'พร้อมเบิก',
      width: '5rem',
      class: 'text-right',
    },
    unit,
    status: {
      ...status,
      filter: (val: string, row: any) => translateSubJobStatus(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      class: {
        text: (val: string, row: any) => statusClassMap(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      },
    },
    heat_treatment,
    surface_treatment,
    target_date,
    remarks,
    leadTime,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'withdrawn_amount',
    'purchased_amount',
    'unit',
    'status',
    'heat_treatment',
    'surface_treatment',
    'target_date',
  ],
};
